export default "__VITE_ASSET__eHWc3KyU__"